// import {API} from "./config";
import { RS_API,API_CANDIDATE } from "./config";

// export const VALIDATE_USER = `${API}/v1/api/create-user/validate`;

// export const SIGN_UP = `${API}/v1/api/auth/verify/signup`;

// export const SIGN_UP_PASS = `${API}/v1/api/auth/signup`;

// export const SIGIN = `${API}/v1/api/auth/verify/login`;

// export const SIGN_IN_PASS = `${API}/v1/api/auth/login`;

// export const UPLOAD = `${API}/v1/api/upload/upload-resume`;

export const VIEW_PUBLISHED_JOBS = `${RS_API}/v1/api/published-job/can`

export const REFERAL_CANDI_API = `${RS_API}/v1/api/refer-candidate`

export const APPLY_JOBS_API = `${API_CANDIDATE}/v1/api/candidate-tracking`

export const GET_APPLY_JOBS_API = `${API_CANDIDATE}/v1/api/candidate-tracking/requirements`

export const SEARCH_APPLY_JOBS_API = `${RS_API}/v1/api/job-search`
export const GET_MATCHED_JOBS = `${RS_API}/v1/api/candidate-tag-search/can`

